import React, { useState } from "react"

import DropDown from "../../components/DropDown"
import TextInput from "../../components/TextInput"
import { toast } from 'react-toastify'
import Loading from "../../components/Loading"
import Pagination from "./../Pagination"
import GroupFolderItem from "./../GroupFolderItem"

import Search from './../../images/icons/search.png'
import Arrow from './../../images/icons/arrow-bg.png'
import VideoFile from './../../images/icons/video-file.png'
import AudioFile from './../../images/icons/audio-file.png'
import TextFile from './../../images/icons/text-file.png'
import FileFile from './../../images/icons/file-file.png'
import Folder from './../../images/icons/folder.png'

import { apiCall, videoExtensions, getExtension, audioExtensions, textExtensions, validateToken } from './../../../Helper'
import { useEffect } from "react"

export default () => {
  const [selectedFilter, setSelectedFilter] = useState({ id: 0, title: 'همه' })
  const [isLoading, setIsLoading] = useState(true)
  const [routes, setRoutes] = useState([])
  const [files, setFiles] = useState([])
  const [folders, setFolders] = useState([])
  const [count, setCount] = useState(0)
  const [page, setPage] = useState(1)
  const [q, setQ] = useState('')

  function getGroups() {
    apiCall({
      url: '/adminPanel/generalGroups',
      params: { user: true, type_id: 1, sub_to_id: routes.length > 0 ? routes[routes.length - 1].id : '' }
    }).then(res => {
      if (res && res.data) {
        setFolders(res.data)
      }
    }).catch(err => { toast.error('مشکل در سیستم'); setIsLoading(false) })
  }
  function getFiles() {
    setIsLoading(true)
    apiCall({
      url: '/tutorials/files',
      params: {
        q, all: true, page: page - 1,
        group_id: routes.length > 0 ? routes[routes.length - 1].id : '',
        ext: selectedFilter.id || '', user: true
      }
    }).then(res => {
      setIsLoading(false)
      if (res && res.data) {
        setFiles(res.data.all)
        setCount(res.data.count)
      }
    }).catch(err => { toast.error('مشکل در سیستم'); setIsLoading(false) })
  }

  useEffect(() => validateToken(), [])

  useEffect(() => {
    if (routes.length === 0)
      setSelectedFilter({ id: 0, title: 'همه' })
    getGroups()
  }, [routes])

  useEffect(() => {
    if (q === '')
      getFiles()
  }, [q])

  useEffect(() => {
    if (!isLoading)
      getFiles()
  }, [selectedFilter, page, routes])

  return (
    <div>
      <h3 className="m-0 text-shadow font-16 pr-16">همه فایل ها</h3>
      <hr className="mb-0" />

      {/* filters */}
      <div className="p-32 pb-0 flexed justify-between">
        <div>
          {routes.length > 0 && <DropDown style={{ width: 330 }} name="دسته بندی بر اساس"
            items={[{ id: 0, title: 'همه' }, { id: 1, title: 'فایل های تصویری' },
            // { id: 2, title: 'فایل های صوتی' }, 
            { id: 3, title: 'فایل های متنی' }]}
            onItemClick={setSelectedFilter} selectedItem={selectedFilter} />}
        </div>

        <TextInput className="w-256" placeholder="جستجو در محتوای فایل ها" onClick={getFiles} icon={Search} onChange={e => setQ(e.target.value)} onKeyDown={e => {
          if (e.keyCode === 13) page === 1 ? getFiles() : setPage(1)
        }} />
      </div>

      {/* routes */}
      <div className="mt-16 px-32" style={{ minHeight: 27 }}>
        {routes.length > 0 && <button className="bd-none bg-none icon-button ml-8 mr-16 p-0" onClick={() => setRoutes(routes.slice(0, routes.length - 1))}>
          <img className="icon-sm valign-mid button blocked" src={Arrow} alt="" />
        </button>}
        {routes.length > 0 && routes.map(item => (
          <React.Fragment key={item.id}>
            <button className="bd-none bg-none icon-button iran-sans font-9 text-semi-disabled" style={{ whiteSpace: 'pre' }}>{item.title}</button>
            <span className="text-semi-disabled">&rsaquo;</span>
          </React.Fragment>
        ))}
      </div>

      {/* folders */}
      {(!q || routes.length > 0) && folders.length > 0 && <div className="px-32 pt-45 grid" style={{ gridTemplateColumns: `repeat(${folders.length > 0 ? '2' : '1'}, 1fr)`, gridGap: 32 }}>
        {
          folders.map(item => (
            <GroupFolderItem className="w-100" key={item.id} title={item.title} icon={Folder}
              onClick={(() => setRoutes([...routes, item]))}
              secondaryTitle={routes.length > 0 ? item.count : undefined} />
          ))
        }
      </div>}

      {/* files */}
      <div className="px-32 pt-64 grid" style={{ gridTemplateColumns: `repeat(${files.length > 0 ? '2' : '1'}, 1fr)`, gridGap: 32 }}>
        {
          files.length > 0 &&
          files.map(item => (
            <div key={item.id} className="text-center button" title={item.name}>
              <a href={`/files/list/${item.id}`} target="_blank">
                <GroupFolderItem className="w-100" key={item.id} title={`کد فایل: ${item.id} - ${item.name}`}
                  icon={
                    videoExtensions.includes(getExtension(item.ext)) ? VideoFile :
                      audioExtensions.includes(getExtension(item.ext)) ? AudioFile :
                        textExtensions.includes(getExtension(item.ext)) ? TextFile : FileFile
                  } price={item?.price} />
              </a>
            </div>
          ))
        }
      </div>

      <Loading show={isLoading} full />
      <br />
      {!isLoading && <Pagination currentPage={page} count={Math.ceil(count / 50)} setPage={setPage} />}
    </div>
  )
}
